import React from "react";
import CalloutSection from "../../UI/CalloutSection/CalloutSection";
import image from "../../../assets/images/students-in-the-arctic--resized.jpg";
import classes from "./ResearchMessage.module.css";

const ResearchMessage = (props) => (
  <CalloutSection image={image} alt="Student and Professor working together">
    <p className={classes.ResearchMessage}>
      Research and fieldwork opportunities are available as early as your first
      year. You’ll work closely with faculty in the Arctic, in Greece, in the
      Everglades and right here in Central PA. Internships and externships also get
      our students out of the classroom, gaining real world experience all
      around the world.
    </p>
  </CalloutSection>
);

export default ResearchMessage;
